<template>
  <IonPage>
    <master-layout @refreshPage="reRender" page-title="دریافتی ها">
      <Loading v-if="!loaded"></Loading>
      <div v-if="loaded">
      <AjaxForm route="incoming/add" :callback="addCallback">
          <ion-card-content class="mb-1">
            <ali-ajax-select v-if="!have_mission_item" :on-change="changeCustomer" route="getCustomerForSelect"
                             title="نام / شماره تلفن مشتری (بدون صفر)" itemTitle="fullname" name="customer_id"
                             :selected="(customer?[customer]:[])"
                             desc="جستجو نام مشتری" itemId="_id">
            </ali-ajax-select>

            <div v-if="customer">
            <div class="space-between pb-2 pt-2">
              <div>
                <div class="mb-1">مشتری: {{ customer.fullname }}</div>
                <div class="mb-1"><i class="far fa-phone"></i>&nbsp;{{ customer.phone }}</div>
                <div>موجودی:
                  <Money :number="Math.abs(customer.balance)"></Money>
                  &nbsp;<span class="text-danger" v-if="customer.balance < 0">بدهکار</span>
                  <span class="text-success" v-else-if="customer.balance >0">طلبکار</span>
                  <span class="text-success" v-else>تسویه</span>
                </div>
              </div>
              <div>
                <button type="button" @click="addItemToList()" class="btn btn-info">افزودن آیتم</button>
              </div>
            </div>
            <div v-if="have_mission_item">
              <input type="hidden" name="mission_item_id" readonly :value="mission_item._id">
              <input type="hidden" name="customer_id" readonly :value="customer._id">
              <hr>
              <div v-if="mission_item.entity_type === 'customer'">
                <div>مأموریت گرفتن سند از مشتری : </div>
                <div>شماره مأموریت : {{mission.mission_number}}</div>
                <div class="mt-1">مبلغ درخواست شده :
                  <Money :number="mission_item.amount"></Money>&nbsp;تومان
                </div>
              </div>
              <div v-if="mission_item.entity_type === 'order'">
                <div>سند دریافتی برای سفارش : </div>
                <div class="mt-1" >شماره سفارش :
                  {{mission_item.order.order_number}}
                </div>
                <div class="mt-1">مبلغ سفارش : {{mission_item.order.total}}</div>
                <div class="mt-1">مبلغ باقی مانده سفارش :
                  {{mission_item.order.remaining_payment_amount}}
                </div>
                <div class="mt-1">تاریخ سفارش : {{mission_item.order.date}}</div>
              </div>
              <div v-if="mission_item.entity_type === 'contract'">
                <div>سند قراردادی سفارش : </div>
                <div class="mt-1">شماره سند : {{mission_item.contract.number}}</div>
                <div>مبلغ سند :
                  <Money :number="mission_item.contract.total"></Money>&nbsp;تومان
                </div>
                <div v-if="false">اینجا باید اطلاعات نشون داده بشه که چه اسنادی ثبت شده</div>
              </div>
            </div>
            </div>
            <hr>
            <div v-if="items.length && customer" class="space-between ">
              <div>
                تعداد کل سند: {{ items.length }}
              </div>
              <div>
                <div>مبلغ کل:
                  <Money :number="total_price"></Money>
                  تومان
                </div>
              </div>
            </div>


          </ion-card-content>
          <IonCard v-for="(item,index) in items" :key="item.id">
            <IonCardContent>
              <div>
                <i @click="removeItemFromList(index)" class="far fa-trash-alt remove-btn"></i>
                <i @click="addItemToList()" class="fa fa-plus add-btn"></i>
                <div class="form-group">
                  <input hidden="" readonly name="id[]" :value="item.id" type="hidden">
                  <label>نوع سند</label>
                  <select v-model="item.doc_type_id" class="form-control" name="doc_type_id[]">
                    <option v-for="(d,index) in doc_types" :key="index" :value="d._id">{{ d.title }}</option>
                  </select>
                </div>
                <div class="form-group">
                  <label>تاریخ سند</label>
                  <date-input v-model="item.due_date" name="due_date[]" placeholder="تاریخ سند..."></date-input>
                </div>
                <div class="form-group">
                  <label>مبلغ</label>
                  <NumberInput name="price[]" @input="(e)=>{item.price=e}" v-model="item.price" :value="item.price"
                               placeholder="مبلغ سند"/>
                </div>
                <div class="form-group">
                  <label>شماره</label>
                  <input v-model="item.number" autocomplete="off" type="text" name="number[]" class="form-control" placeholder="شماره">
                </div>
                <div class="form-group">
                  <input v-model="item.content" autocomplete="off" type="text" name="content[]" class="form-control" placeholder="شرح سند..">
                </div>
                <div class="form-group">
                  <label>فایل مربوط به سند</label>
                  <input class="form-control" :name="'file_'+item.id" type="file" accept="image/*">
                </div>
              </div>
            </IonCardContent>
          </IonCard>
        <button type="submit" id="submit_btn" class="d-none"></button>
      </AjaxForm>
      <div class="gap_div"></div>
      </div>
    </master-layout>
    <button @click="submitBtnClick()" v-if="customer && items.length && loaded" type="submit" class="submit_btn mt-0 btn btn-success btn-block">ثبت سند
      دریافتی
    </button>
  </IonPage>
</template>

<script>
import AjaxForm from "@/components/AjaxForm";
import AliAjaxSelect from "@/components/aliAjaxSelect";
import Money from "@/components/Money";
import {mapActions} from "vuex";
import {
  IonCard,IonCardContent,IonPage
} from "@ionic/vue";
import NumberInput from "../../components/NumberInput";
import Loading from "../../components/Loading";
import {compressImage, makeCode, showSystemNoti} from "@/shared/helper"
import DateInput from "@/components/DateInput.vue";

export default {
  name: "add",
  components: {DateInput, Loading, AjaxForm,AliAjaxSelect,Money,IonCardContent,IonCard,NumberInput,IonPage},
  data(){
    return {
      items: [],
      total_price: 0,
      customer_id: null,
      customer: null,
      doc_types : [],
      resetCustomerSelect : 1,
      mission_item : null,
      mItemId : null,
      have_mission_item : false,
      loaded : false,
      cc : null
    }
  },
  async mounted()
  {
    const check = await this.getDocTypes();
    if (check && check.ok)
      this.doc_types = check.doc_types;
    this.init();
  },
  methods: {
    async handelImageInput (event,id)
    {
      console.log(event)
     //  console.log('is change');
     //  const added_file = event.target.files;
     const files = await compressImage(event);
      console.log('files is :',files)
      document.querySelector('#input_'+id).files = files

     //  let file = result.file;
     //  const fileType = added_file[0].type;
     //  console.log(fileType)
     //  file=new File([file], file.name, {type:fileType});
     //
     //
     //  let container = new DataTransfer();
     //  container.items.add(file);
     //  console.log(container)
     //  document.querySelector('#xx').files = container.files;
     //
     //  event.target.files.value = result.file
    },
    submitBtnClick()
    {
      document.getElementById('submit_btn').click();
    },
    async init()
    {
      this.loaded = false;
      this.customer_id = null;
      this.customer = null;
      let customer_id = this.$route.params.customer_id;
      if (customer_id)
      {
        //اطلاعات مشتری رو میگیرم و برای اون سند رو ثبت میکنم
        const check = await this.getCustomer(customer_id);
        if (check)
        {
          if (check.ok)
          {
            this.customer_id = customer_id;
            this.customer = check.customer;
          }
        }
      }
      this.items = [];
      this.total_price = 0;
      this.resetCustomerSelect = Math.round(6)*1000;
      this.mItemId = this.$route.query.mItemId;
      if (this.mItemId)
      {
        const result = await this.getPaymentMissionItemFullInfo(this.mItemId);
        if (result && result.ok)
        {
          this.have_mission_item = true;
          this.mission = result.mission;
          this.mission_item = result.item_info;
          this.customer = this.mission_item.customer;
        }
      }
      this.loaded = true;
    },
    ...mapActions('incoming',{
      getDocTypes : 'getDocTypes'
    }),
    ...mapActions('mission',{
      getPaymentMissionItemFullInfo : 'getPaymentMissionItemFullInfo'
    }),
    ...mapActions('customer',{
      getCustomer : 'getCustomer'
    }),
    addItemToList()
    {
      this.items.push({price : 0,id : makeCode(5)});
      this.changeItemsEvent();
    },
    removeItemFromList(index)
    {
      this.items.splice(index,1);
      this.calculateSumPrice();
      this.changeItemsEvent();
    },
    changeItemsEvent()
    {
      for (let i = 0; i < this.items.length; i++)
      {
        this.items[i].change = Math.random()*10000;
      }
    },
    changeItemAmount : function (event,index)
    {
      if(isNaN(event.target.value))
        this.items[index].price = 0;
      else
        this.items[index].price = parseInt(event.target.value);

      this.calculateSumPrice();


    },
    calculateSumPrice()
    {
      this.total_price = 0;
      for(let i = 0; i < this.items.length; i++)
      {
        if (this.items[i].price && !isNaN(this.items[i].price))
          this.total_price += parseInt(this.items[i].price);
      }
    },
    changeCustomer: async function (items)
    {
      if (items && items.length)
      {
        this.customer = items[0];
      }
      else
        this.customer = null;
    },
    addCallback(data)
    {
      if (data.ok)
      {
        this.init();
        showSystemNoti('success',data.message);
      }
      else
        showSystemNoti('danger',data.error);
    },
    changeDate(value,index)
    {
      console.log(value)
      this.items[index].due_date = value;
    },
    reRender()
    {
      this.init();
    }
  },
  watch : {
    items:{
      handler()
      {
        this.calculateSumPrice();
      },deep:true,
    },
    "$route.path": {
      handler(newUrl,oldUrl)
      {
        if (newUrl.toLowerCase().indexOf('incoming/add') >= 0 && oldUrl.toLowerCase().indexOf('incoming/add') < 0)
        {
          this.init()
        }
      },
      deep:true
    },
  }
}
</script>

<style scoped>
.submit_btn
{
  position: fixed;
  bottom: 0!important;
  margin-bottom: 58px;
}
.doc-item-box {
  border: 1px dashed #000;
  padding: 25px 15px 10px 15px;
  border-radius: 5px;
  margin-bottom: 20px;
  background-color: #f8f8f8;
  position: relative;
}
.remove-btn {
  left: 0;
  position: absolute;
  padding: 5px;
  font-size: 20px;
  top: -5px;
  color: #cc1d1d;
}
.add-btn {
  left: 45px;
  position: absolute;
  padding: 5px;
  font-size: 20px;
  top: -5px;
  color: #2dd36f;
}
.form-group
{
  display: flex;
  justify-content: space-between;
}
.form-group label
{
  width: 100px;
}

.mb-1
{
  margin-bottom: 4px;
}
.space-between {
  display: flex;
  justify-content: space-between;
}

.p-1
{
  padding: 5px;
}
.p-2
{
  padding: 10px;
}
.pt-2
{
  padding-top: 8px;
}
.pb-2
{
  padding-bottom: 8px;
}
.page-div {
  overflow-y: auto;
  height: calc(100vh - 146px) !important;
}
.mt-0
{
  margin-top: 0!important;
}
.d-none
{
  display: none;
}
.gap_div
{
  height: 37px;
  background: transparent;
}

</style>